import { styled, Typography, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(({ theme }) => ({
  padding: theme.spacing(16, 0, 12),
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(12, 0, 8),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(8, 0, 6),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.blueColors?.PLUS_2,
  textDecoration: 'none',
}));
